import { render, staticRenderFns } from "./AssistenteRecomendacao.vue?vue&type=template&id=01fc798a&scoped=true&"
import script from "./AssistenteRecomendacao.vue?vue&type=script&lang=js&"
export * from "./AssistenteRecomendacao.vue?vue&type=script&lang=js&"
import style0 from "./AssistenteRecomendacao.vue?vue&type=style&index=0&id=01fc798a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc798a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
